var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/verification/steps/age-verification.tsx";
import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import snackbar from 'soapbox/actions/snackbar';
import { verifyAge } from 'soapbox/actions/verification';
import { Button, Datepicker, Form, Text } from 'soapbox/components/ui';
import { useAppDispatch, useAppSelector } from 'soapbox/hooks';
const messages = defineMessages({
  fail: {
    "id": "age_verification.fail",
    "defaultMessage": "You must be {ageMinimum, plural, one {# year} other {# years}} old or older."
  }
});
function meetsAgeMinimum(birthday, ageMinimum) {
  const month = birthday.getUTCMonth();
  const day = birthday.getUTCDate();
  const year = birthday.getUTCFullYear();
  return new Date(year + ageMinimum, month, day) <= new Date();
}
const AgeVerification = () => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector(state => state.verification.isLoading);
  const ageMinimum = useAppSelector(state => state.verification.ageMinimum);
  const siteTitle = useAppSelector(state => state.instance.title);
  const [date, setDate] = React.useState('');
  const isValid = typeof date === 'object';
  const onChange = React.useCallback(date => setDate(date), []);
  const handleSubmit = React.useCallback(event => {
    event.preventDefault();
    const birthday = new Date(date);
    if (meetsAgeMinimum(birthday, ageMinimum)) {
      dispatch(verifyAge(birthday));
    } else {
      dispatch(snackbar.error(intl.formatMessage(messages.fail, {
        ageMinimum
      })));
    }
  }, [date, ageMinimum]);
  return /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "pb-4 sm:pb-10 mb-4 border-b border-gray-200 dark:border-gray-600 border-solid -mx-4 sm:-mx-10",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-center font-bold text-2xl",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "age_verification.header",
    defaultMessage: "Enter your birth date",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "sm:pt-10 md:w-2/3 mx-auto",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleSubmit,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Datepicker, {
    onChange: onChange,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 11
    }
  }, siteTitle, " requires users to be at least ", ageMinimum, " years old to access its platform. Anyone under the age of ", ageMinimum, " years old cannot access this platform."), /*#__PURE__*/React.createElement("div", {
    className: "text-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Button, {
    block: true,
    theme: "primary",
    type: "submit",
    disabled: isLoading || !isValid,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 13
    }
  }, "Next")))));
};
export default AgeVerification;